import { render, staticRenderFns } from "./MarkCupboard.vue?vue&type=template&id=1dea4c82&scoped=true&"
import script from "./MarkCupboard.vue?vue&type=script&lang=js&"
export * from "./MarkCupboard.vue?vue&type=script&lang=js&"
import style0 from "./MarkCupboard.vue?vue&type=style&index=0&id=1dea4c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dea4c82",
  null
  
)

export default component.exports